<template>
  <div
    :class="{
      'checkbox-label': true,
      'checkbox-label--enabled': enabled,
      'checkbox-label--disabled': !enabled,
      'checkbox-label--selected': value,
    }"
    @click="toggle()"
  >
    <span v-if="html" v-html="text" />
    <span v-else>{{ text }}</span>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    value: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    html: {
      type: Boolean,
      required: false,
    },
  },
})
export default class CheckBoxLabel extends Vue {
  toggle () {
    if (this.enabled) {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss">
.checkbox-label {
  font-weight: 300;
  font-size: 14px;
  margin-left: 5px;
  outline: none;

  &--selected {
    color: #005ca9;
  }

  &--disabled {
    color: #ADADAD;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckBoxLabel.vue